module.exports = __webpack_public_path__ + "img/icon-eye.7fa8b1ec.svg";